import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Modal from '../../ui/Modal';
import Input from '../../ui/Input';
import Button from '../../ui/Button';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { staggerContainer, staggerItem } from '../../utils/animations';

const REGISTER_URL = 'https://78zlbvfffg.execute-api.us-east-1.amazonaws.com/prod/api/register';

function WhatsAppConnectModal({ open, onClose, onConnectSuccess }) {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { getSessionIdToken } = useAuth();
  const [accessToken, setAccessToken] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const token = accessToken.trim();
    const number = whatsappNumber.trim();
    if (!token || !number) {
      toast('Please enter Access Token and WhatsApp Number.', 'error');
      return;
    }
    setLoading(true);
    try {
      const idToken = await getSessionIdToken();
      if (!idToken) {
        toast('Please sign in to connect WhatsApp.', 'error');
        onClose();
        navigate('/signin');
        return;
      }
      const response = await fetch(REGISTER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ whatsappNumber: number, token }),
      });
      console.log(response);
      if (response.status === 401) {
        toast('Session expired. Please sign in again.', 'error');
        onClose();
        navigate('/signin');
        return;
      }
      const data = await response.json().catch(() => ({}));
      if (!data.success) {
        const err = data.message || data.error_message || 'Registration failed';
        toast(err, 'error');
        return;
      }
      toast('WhatsApp connected successfully.', 'success');
      if (typeof onConnectSuccess === 'function') {
        onConnectSuccess(number);
      }
      onClose();
      navigate('/app');
    } catch (error) {
      console.log(error);
      toast('Failed to connect WhatsApp. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Connect WhatsApp">
      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.1 }}
      >
        <motion.div
          className="auth-form-fields"
          variants={staggerContainer}
          initial="initial"
          animate="animate"
        >
          <motion.div variants={staggerItem}>
            <Input
              label="Access Token"
              name="accessToken"
              type="text"
              value={accessToken}
              onChange={function (e) { setAccessToken(e.target.value); }}
              placeholder="Enter your access token"
              autoComplete="off"
              required
            />
          </motion.div>
          <motion.div variants={staggerItem}>
            <Input
              label="WhatsApp Number"
              name="whatsappNumber"
              type="tel"
              value={whatsappNumber}
              onChange={function (e) { setWhatsappNumber(e.target.value); }}
              placeholder="Enter your WhatsApp number"
              autoComplete="tel"
              required
            />
          </motion.div>
        </motion.div>
        <motion.div
          variants={staggerItem}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Button type="submit" variant="primary" fullWidth className="auth-form-submit" disabled={loading}>
            Connect WhatsApp
          </Button>
        </motion.div>
      </motion.form>
    </Modal>
  );
}

export default WhatsAppConnectModal;
